import React, { Component } from 'react';

//components
import MultiUploadFileBox from "../../../../generic_components/components/upload_file_boxes/MultiUploadFileBox";
import HtmlTextBlock from "../../../../generic_components/components/text_display/HtmlTextBlock";

//generic functions
import {
    isEmpty
} from "../../../../functions/generic_functions";
/*
    props:
        onFileUpload => call back function to handle file upload
        onFileDelete => call back function to handle file deletion
        onFileReplaceUpload => call back function to handle file replace upload
        onChangeSetParentState: call back function to update parent state
        maxFileSize: int, max file size in bytes
        staticUiData: {
            documentList: [
                {
                    
                    doc_type => "name of the document", 
                    max_docs => int, number of maximum docs allowed
                    min_docs => int, number of minimum documents required for minimum upload
                    required => the minimum number of documents is required and the upload file upload box is required
                    files: [
                        {
                            fileName => file name
                            uploadDate => updated date, eg. 2019-06-18 17:03:53
                            fileSize => file size in bytes
                            app_docs_id => doc id of this document
                        }
                    ]
                }
            ],
        }
*/

class CariUploadDocumentsPanel extends Component {

    constructor(props) {
        super(props);

        //rendering UI functions
        this.renderSingleFileUploadPanel = this.renderSingleFileUploadPanel.bind(this);
        this.renderMultiFileUploadPanel = this.renderMultiFileUploadPanel.bind(this);
        this.renderMultiFilePanelDetails = this.renderMultiFilePanelDetails.bind(this);
        this.renderFilePanels = this.renderFilePanels.bind(this);
    }

    //renders the description with the number of minimum documents and maximum files allowed for this file panel
    renderMultiFilePanelDetails(data) {

        var numFileDescriptionStr = "";
        var numFileDescriptionMinStr = "";
        var numFileDescriptionMaxStr = "";

        //if minimum == maximum docs
        if (data.min_docs === data.max_docs) {
            numFileDescriptionStr = "<strong>" + data.max_docs + " Files </strong> are required.";
        }
        //if specified other values
        else {
            //minimum has at least more than 1
            if (data.min_docs >= 1) {

                numFileDescriptionMinStr = "<strong>minimum of " + data.min_docs + " file" + ((data.min_docs > 1) ? "s" : "") + "</strong> " + ((data.min_docs > 1) ? "are" : "is") + " required";
            }
            //doc has at least more than one
            if (data.max_docs >= 1) {
                numFileDescriptionMaxStr = "<strong>maximum of " + data.max_docs + " files </strong> will be accepted";
            }
        }

        //combine both strs if both are not empty
        if (numFileDescriptionMinStr !== "" && numFileDescriptionMaxStr !== "") {
            numFileDescriptionStr = "A " + numFileDescriptionMinStr + " and a " + numFileDescriptionMaxStr + ".";
        }
        //if max is not empty
        else if (numFileDescriptionMaxStr !== "" && numFileDescriptionMinStr === "") {
            numFileDescriptionStr = "A " + numFileDescriptionMaxStr + ".";
        }
        
        return numFileDescriptionStr;
    }

    //renders a single file panel
    renderSingleFileUploadPanel(data, i) {
        return (
            <div key={i}>
                {i !=0 ? <div><br/><br/></div>:null}
                <div className="p-grid align_center">
                    <div className="p-col-3">
                        <label className={"label_style"}>
                            {data.doc_type} {(data.required) ? <strong className="sfu_red">*</strong> : null}
                        </label>
                    </div>
                    <div className="p-col-1">
                    </div>
                    <div className="p-col-8 no_padding_right">
                        <MultiUploadFileBox
                            files={data.files}
                            name={data.doc_type}
                            minNumFiles={data.min_docs}
                            maxNumFiles={data.max_docs}
                            required={data.required}
                            onChangeSetParentState={this.props.onChangeSetParentState}
                            uploadBySubmit={false}
                            onFileUpload={this.props.onFileUpload}
                            onFileDelete={this.props.onFileDelete}
                            onFileReplaceUpload={this.props.onFileReplaceUpload}
                            onSaveAddCommentsToDocsUploadedModal={this.props.onSaveAddCommentsToDocsUploadedModal}
                            enableDeleteMode={data.enableDeleteMode}
                            doc_type={data.doc_type}
                            displayComment={true}
                        />
                    </div>
                </div>
            </div>
        );
    }

    //renders a multi file panel
    renderMultiFileUploadPanel(data, i) {
        return (
            <div key={i}>
                {i !=0 ? <div><br/><br/><br/></div>:null}
                <div className="p-grid cari_form_row_padding">
                    <div className="p-col-3">
                        <label className={"label_style"}>
                            {data.doc_type} {(data.required) ? <strong className="sfu_red">*</strong> : null}
                        </label>
                        <br />
                        <HtmlTextBlock
                            text={this.renderMultiFilePanelDetails(data)}
                            className={"label_style"}
                        />
                    </div>
                    <div className="p-col-1">
                    </div>
                    <div className="p-col-8 no_padding_right">
                        <MultiUploadFileBox
                            files={data.files}
                            name={data.doc_type}
                            minNumFiles={data.min_docs}
                            maxNumFiles={data.max_docs}
                            required={data.required}
                            onChangeSetParentState={this.props.onChangeSetParentState}
                            uploadBySubmit={false}
                            onFileUpload={this.props.onFileUpload}
                            onFileDelete={this.props.onFileDelete}
                            onFileReplaceUpload={this.props.onFileReplaceUpload}
                            onSaveAddCommentsToDocsUploadedModal={this.props.onSaveAddCommentsToDocsUploadedModal}
                            enableDeleteMode={data.enableDeleteMode}
                            doc_type={data.doc_type}
                            displayComment={true}
                        />
                    </div>
                </div>
            </div>
        );
    }

    //render many single upload boxes
    renderFilePanels() {
        var tempFilePanelList = [];
        if (!isEmpty(this.props.staticUiData.documentList) && this.props.staticUiData.documentList.length > 0) {
            this.props.staticUiData.documentList.map((data, i) => {

                //if more than one max, render multi
                if (data.max_docs > 1) {
                    tempFilePanelList.push(this.renderMultiFileUploadPanel(data, i));
                }
                //if only 1 max, render single
                else {
                    tempFilePanelList.push(this.renderSingleFileUploadPanel(data, i));
                }
                return null;
            });
        }
        return tempFilePanelList;
    }

    render() { 
        return (  
            <div>
                {this.renderFilePanels()}

            </div>
        );
    }
}
 
export default CariUploadDocumentsPanel;